import React from 'react'
import { useDispatch } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import EditPasswordForm from 'Employee/profile/EditPasswordForm'
import { closeModal } from 'store/actions/modals'

const ResetPasswordModal = () => {
  const dispatch = useDispatch()

  return (
    <BaseModal hideButtons title={`components.resetPassword.RESET_PASSWORD_MODAL`} shouldCloseOnOverlayClick={false}>
      <EditPasswordForm finishChanges={() => dispatch(closeModal())} preventCancel />
    </BaseModal>
  )
}

export default ResetPasswordModal
